import {useEffect, React} from "react";
import "../styles/about.css";
import Layout from "../tools/layout";
import firstImg from "../assets/images/firstImg.png";

function About() {
  useEffect(() => {
    document.title = "About | Ion Niculica";
  }, []);

  return (
    <Layout>
      <section className="about">
        <div className="about-container">

          {/* PROFILE */}
          <div className="profile-about">
            <img
              src={firstImg}
              className="first-image-about"
              alt="Profile"
            />

            <div className="profile-about-info">
              <h1>👋</h1>
              <p>
                I'm Ion Niculica, currently a student in a French preparatory engineering program. I'm fascinated by understanding how systems work and exploring ways to improve them. I also have a strong passion for creating beautiful, minimalist designs—because I believe that simplicity is what truly makes a difference.
              </p>
            </div>
          </div>

          {/* JOURNEY */}
          <div className="section">
            <h1>The journey</h1>

            <p>
              <strong>Alone</strong> — I started my journey into programming in 2017 by experimenting with SA-MP server creation using Pawn. Even though I didn’t succeed at the time, it was enough to spark a real passion. From there, I naturally moved into web development, spending years building projects like online stores and personal portfolios, constantly learning along the way.
            </p>
            <p>
              <strong>Chastagner</strong> — Later, I joined Chastagner as an intern. I worked across different parts of the workflow — from receiving to final sale — which helped me become more autonomous and comfortable in a professional environment. This experience even led to a job offer.
            </p>
            <p>
              <strong>Sofratherm</strong> — Before that, I had my first professional exposure at Sofratherm. Working with the electrical team, I developed strong technical foundations in electromechanics and learned the importance of precision, rigor, and quality work.
            </p>
          </div>

          {/* BELIEFS */}
          <div className="section">
            <h1>What I Believe</h1>
            <p>
              For many years, I have had a vision: to help people through meaningful work. I believe technology should not only advance, but also improve lives—and both can go hand in hand.
              To achieve this, we need kindness, rigor, and a strong sense of purpose:
            </p>
            <ul>
              <li><strong>Prioritize</strong> real human needs before creating solutions.</li>
              <li><strong>Design</strong> truly inclusive and accessible tools.</li>
              <li><strong>Uphold</strong> responsibility for the impact of our work.</li>
            </ul>
          </div>
          {/* OTHER STUFF */}
          <div className="section">
            <h1>Beyond Work</h1>
            <p>
              Outside of my studies, I enjoy spending time with my family and talking with friends. I also like reading from time to time, and I especially enjoy walking in nature and watching the stars at night 🌠.

            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default About;